module.exports = __webpack_public_path__ + "img/bannerBlue.cec1721d.jpg";